<template>
    <div>
        <div class="markdown prose">
            <p class="text-black01 font-weight-bold">Smart choice! 🚀</p>
            <p><span class="text-black01 font-weight-bold">Autopilot</span> uses ERC-5173’s protocol to automate disciplined, zero-sum-proof trading. Your capital grows steadily—no sleepless nights, no emotional missteps.</p>
            <p><span class="text-black01 font-weight-bold">✨ Good news: </span>You’re eligible for our private preview (invite-only).</p>
            <p><span class="text-black01 font-weight-bold">Next Step: </span>Secure your spot now. Limited seats remaining.</p>
            <!-- 响应操作 -->
            <ResponseAction @updateResponse="$emit('updateResponse')"></ResponseAction>
            <br><hr>
            <div class="mt-6 flex-col md:flex-row space-y-6 md:space-y-0 md:space-x-6">
                <Button variant="primary" rounded="xl" color="black03" height="40" width="300" aria-label="Join Autopilot Waitlist" @click="requestAutopilotDialog = true">
                    <span class="px-4">Join Autopilot Waitlist<v-icon>mdi mdi-chevron-right</v-icon></span>
                </Button>
                <Button variant="secondary" rounded="xl" color="black01" height="40" aria-label="Start Over" @click="$emit('startOver')">
                    <span class="px-4">Start Over<v-icon>mdi mdi-chevron-right</v-icon></span>
                </Button>
            </div>
            <p class="font-italic">“Set it, forget it—and let shared success begin.”</p>
        </div>
        <!-- 发送请求 Autopilot 邀请码弹窗 -->
        <RequestAutopilot :show="requestAutopilotDialog" @closeDialog="closeRequestAutopilotDialog"></RequestAutopilot>
    </div>
</template>
<script>
import ResponseAction from "@/views/ai/components/ResponseAction.vue";
import RequestAutopilot from "@/views/ai/components/RequestAutopilot.vue";
export default {
    data(){
        return {
            requestAutopilotDialog: false,
        }
    },
    components: { ResponseAction, RequestAutopilot },
    created(){

    },
    mounted(){

    },
    computed: {

    },
    watch:{

    },
    methods: {
        closeRequestAutopilotDialog(show) {
            this.requestAutopilotDialog = show;
        },
    }
}
</script>
<style scoped>

</style>